import { memo } from 'react';

import './ResetPasswordModal.css';
import { useTranslation } from 'react-i18next';
import { GeneralModal, GeneralModalNoButtonVariant } from '../GeneralModal';
import { Profile } from '../../../../models/UserStore';
import { AvatarNode } from '../../AvatarNode';

type ResetPasswordModalProps = {
  profile: Profile | undefined | null;
  email: string;
  onClose: () => void;
  isWEA?: boolean;
};

export const ResetPasswordModal = memo(
  ({ profile, email, onClose, isWEA }: ResetPasswordModalProps) => {
    const { t } = useTranslation();
    return (
      <GeneralModal
        onClose={onClose}
        buttonSetting={{
          noText: t('OK'),
          noVariant: isWEA
            ? GeneralModalNoButtonVariant.WEABlue
            : GeneralModalNoButtonVariant.Cyan,
        }}
      >
        <div className="reset-password-general">
          <div className="centered-container">
            <AvatarNode
              avatar={{
                ...profile?.avatar,
                userId: profile?.userId ?? '',
                source:
                  profile?.profilePicture &&
                  profile?.profilePicture.publicUrls?.small
                    ? {
                        uri: profile?.profilePicture.publicUrls.small,
                      }
                    : '',
              }}
              size={125}
            />
            <div className="username">{profile?.name}</div>
            <div className="email">{email}</div>

            <div className="sub-title">
              {t(
                'You should receive an email to reset your password within 5 minutes.',
              )}
            </div>
            <div className="content">
              {t('Please also check your spam folder / junk box.')}
            </div>
          </div>
        </div>
      </GeneralModal>
    );
  },
);
